import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

// Estilos
const StatusItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.8rem;
`;

const Circulo = styled.div<{ cor: string }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${(props) => props.cor};
`;

const TituloModal = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 1rem;
  color: #003644;
`;

// Componente
export default function SituacaoInfoModal() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Ícone de ajuda */}
      <span
        onClick={(e) => {
          e.stopPropagation(); // evita conflitos com dropdowns
          setOpen(true);
        }}
        style={{ marginLeft: 8, cursor: "pointer", display: "inline-flex" }}
      >
       
          <QuestionCircleOutlined style={{ fontSize: 18, color: "#888" }} />
        
      </span>

      {/* Modal de explicação */}
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        title={<TituloModal>Significado das situações</TituloModal>}
      >
        <StatusItem>
          <Circulo cor="#ffffff" style={{ border: "1px solid #ccc" }} />
          <span>Não definido</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#28a745" />
          <span>Alugar</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#28a745" />
          <span>Alugar ou trocar</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#28a745" />
          <span>Trocar</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#28a745" />
          <span>Alugado ou utilizado parcialmente</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#007bff" />
          <span>Será utilizado</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#800080" />
          <span>Reservado pelo próprio</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#800080" />
          <span>Reservado por MC (Multicotas)</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="#800080" />
          <span>Períodos fracionados reservados</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="orange" />
          <span>Fechado parcialmente</span>
        </StatusItem>
        <StatusItem>
          <Circulo cor="red" />
          <span>Fechado</span>
        </StatusItem>
      </Modal>
    </>
  );
}
